// packages/world-model/src/traits/scenery/index.ts

export { SceneryTrait } from './sceneryTrait';
export { SceneryBehavior } from './sceneryBehavior';
